import { Skeleton } from '../../components/Skeleton';

export function InternalDashboardSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between">
        <Skeleton className="h-[50px] w-[600px]" />
        <div className="flex gap-4">
          <Skeleton className="h-[50px] w-[200px]" />
          <Skeleton className="h-[50px] w-[350px]" />
        </div>
      </div>
      <Skeleton className="h-[600px]" />
    </div>
  );
}
